import React, { useState } from "react";
import ChatTab from "./ChatTab";
import SummaryTab from "./SummaryTab";
import TranslateTab from "./TranslateTab";
import ExplainTab from "./ExplainTab";
import NotesTab from "./NotesTab";
import { useLanguage } from "../utils/i18n";

export default function AiPanel({ book, api, width, showToast, notes, onAddNote, onDeleteNote, onRenameNote, onUpdateNote, subfolders, onAddSubfolder, onDeleteSubfolder, onMoveNote, onMoveFolderToParent, folderOrder, onReorderFolderOrder, defaultTab }) {
  const [tab, setTab] = useState(defaultTab || "chat");
  // Lift result state so it survives tab switches
  const [tabResults, setTabResults] = useState({
    summary: null,
    translate: null,
    explain: null,
  });
  // Lift chat messages so they survive tab switches
  const [chatMessages, setChatMessages] = useState([]);
  const setResult = (name) => (val) =>
    setTabResults((prev) => ({ ...prev, [name]: val }));
  const { t } = useLanguage();

  const TABS = [
    { id: "chat",      label: t("tabChat") },
    { id: "explain",   label: t("tabExplain") },
    { id: "summary",   label: t("tabSummary") },
    { id: "translate", label: t("tabTranslate") },
    { id: "notes",     label: t("tabNotes") },
  ];

  const noBookNotice = (
    <div className="no-book-notice">
      <span style={{ fontSize: "3rem" }}>📖</span>
      <p>{t("noBookNotice")}</p>
    </div>
  );

  const renderTab = () => {
    if (tab === "notes") {
      return <NotesTab
        notes={notes}
        onAddNote={onAddNote}
        onDeleteNote={onDeleteNote}
        onRenameNote={onRenameNote}
        onUpdateNote={onUpdateNote}
        subfolders={subfolders || []}
        onAddSubfolder={onAddSubfolder}
        onDeleteSubfolder={onDeleteSubfolder}
        onMoveNote={onMoveNote}
        onMoveFolderToParent={onMoveFolderToParent}
        folderOrder={folderOrder}
        onReorderFolderOrder={onReorderFolderOrder}
      />;
    }
    switch (tab) {
      case "chat":
        return <ChatTab book={book} api={api} onAddNote={onAddNote} messages={chatMessages} setMessages={setChatMessages} />;
      case "explain":
        return <ExplainTab book={book} api={api} showToast={showToast} onAddNote={onAddNote}
                  result={tabResults.explain} onSetResult={setResult("explain")} />;
      case "summary":
        if (!book) return noBookNotice;
        return <SummaryTab book={book} api={api} showToast={showToast} onAddNote={onAddNote}
                  result={tabResults.summary} onSetResult={setResult("summary")} />;
      case "translate":
        if (!book) return noBookNotice;
        return <TranslateTab book={book} api={api} showToast={showToast} onAddNote={onAddNote}
                  result={tabResults.translate} onSetResult={setResult("translate")} />;
      default:
        return null;
    }
  };

  return (
    <div className="ai-panel" style={{ width }}>
      <div className="ai-tabs">
        {TABS.map((tab_item) => (
          <button
            key={tab_item.id}
            className={`ai-tab ${tab === tab_item.id ? "active" : ""}`}
            onClick={() => setTab(tab_item.id)}
          >
            {tab_item.id === "notes" && notes.length > 0
              ? `📋 ${t("tabNotes").replace(/^📋\s*/, "")} (${notes.length})`
              : tab_item.label}
          </button>
        ))}
      </div>
      {renderTab()}
    </div>
  );
}
